import React from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

import moment from 'moment'

import { listF2, setF2Filter } from "../../actions/listF2Act";

import { commonErr } from "../common/errors";
import { timeFilterModes } from "../common/common";

import Header from "../common/header";
import Footer from "../common/footer";
import SideBar from "../common/sidebar";
import SearchBar from "./searchbar";

const SummaryInfoF2 = ({ data }) => {
	return (
		<React.Fragment>
			<tr>
				<th colSpan={2}>Tổng cộng</th>
				<th>{data.requestOrders}</th>
				<th>{data.deposited}</th>
				<th>{data.finishedTrips}</th>
				<th><NumberFormat value={data.finishedTripsPrice} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></th>
				<th>{data.upcomingTrips}</th>
				<th><NumberFormat value={data.upcomingTripsPrice} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></th>
			</tr>
		</React.Fragment>
	)
}


class InfoF2 extends React.Component {
	constructor(props) {
		super(props);
		
	}

	render() {
		const { info, i, data, filter } = this.props;	
		const { requestOrders, deposited, upcomingTrips, finishedTrips, upcomingTripsPrice, finishedTripsPrice } = data;

		return <React.Fragment>
			<tr>
				<td>{i + 1}</td>
				<td><Link className="link" to={{ pathname: `/f2/detail/${info.profile.uid}` }}>{info.profile.name}</Link></td>
				<td>{requestOrders}</td>
				<td>{deposited}</td>
				<td>{finishedTrips}</td>
				<td><NumberFormat value={finishedTripsPrice} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
				<td>{upcomingTrips}</td>
				<td><NumberFormat value={upcomingTripsPrice} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
			</tr>
		</React.Fragment>
	}

}


class TrackingReport extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			requestOrders: 0,
			deposited: 0,
			upcomingTrips: 0,
			upcomingTripsPrice: 0,
			finishedTrips: 0,
			finishedTripsPrice: 0,
			f2Name: "",
			// startDate: moment().set({
			// 	hour: 0,
			// 	minute: 0,
			// 	second: 0,
			// 	milliseconds: 0
			// })
		}
	}

	componentDidMount() {

		const { filter } = this.props.listF2;
		this.setListF2(filter)

	}

	setListF2 = (filter) => {
		this.props.dispatch(listF2(0, 0, filter))
	}

	setF2Filter = (filter) => {
		this.props.dispatch(setF2Filter(filter))
	}

	setTimeMode = (time) => {		
		const { filter } = this.props.listF2
		const data = {
			...filter,
			time: time
		}
		this.setF2Filter(data);
		this.setListF2(data);
	}
	
	onHandleDateChange = (date) => {

		const { filter } = this.props.listF2
		const data = {
			...filter,
			timeInSeconds: date
		}

		this.setF2Filter(data);
		this.setListF2(data);
	}
	
	getInfoOrderInList = (orders) => {
		
		let { requestOrders, deposited, upcomingTrips, upcomingTripsPrice, finishedTrips, finishedTripsPrice } = this.state;

		if (orders !== null && orders ) {

			requestOrders = orders.length;
			deposited = orders.filter(order => (order.status === 4 || order.status === 200)).length;
			let upcomingTripsArr = orders.filter(order => (order.status > 0 && order.status < 5) || order.status > 25);
			upcomingTripsArr.map(order => upcomingTripsPrice += order.price);
			let finishedTripsArr = orders.reduce((c, order) => order.status === 25 ? [...c, order] : c, []);
			finishedTripsArr.map(order => finishedTripsPrice += order.price);

			upcomingTrips = upcomingTripsArr.length; 
			finishedTrips = finishedTripsArr.length;
		
		}
		
		return {requestOrders, deposited, upcomingTrips, upcomingTripsPrice, finishedTrips, finishedTripsPrice} 
	}

	getSumInfoOrder = (listF2) => {
	
		let { requestOrders, upcomingTripsPrice, finishedTripsPrice, deposited, upcomingTrips, finishedTrips } = this.state;

		for (let i = 0; i < listF2.length; i++) {
			if (listF2[i].orders !== null) {
				let data = this.getInfoOrderInList(listF2[i].orders)
				requestOrders += data.requestOrders;
				deposited += data.deposited;
				upcomingTrips += data.upcomingTrips;
				upcomingTripsPrice += data.upcomingTripsPrice;
				finishedTrips	 += data.finishedTrips;
				finishedTripsPrice += data.finishedTripsPrice;
			}
			
		}
		return { requestOrders, deposited, upcomingTrips, upcomingTripsPrice, finishedTrips, finishedTripsPrice }
	}

	onHandleSearchEvents = (title, name) => {
		this.setState({ [name]: title });
	}

	render() {
		let tableContent;
		const { err, listF2, filter } = this.props.listF2;
		const { time, timeInSeconds } = filter
		const { f2Name } = this.state;

		if (err === commonErr.INNIT || err === commonErr.LOADING) {

		} else if (err >= commonErr.SUCCESS) {

			let listF2Filter = listF2.filter(infoF2 => infoF2.profile.name.toLowerCase().indexOf(f2Name.toLowerCase()) !== -1);

			tableContent = <tbody>
				{listF2Filter.length > 0 ? <React.Fragment>{listF2Filter.map((f2, i) => <InfoF2 key={i.toString()} info={f2} i={i} data={this.getInfoOrderInList(f2.orders)} />)}
					<SummaryInfoF2 data={this.getSumInfoOrder(listF2Filter)} /></React.Fragment> 
					:
					<tr><td className="text-center p-4" colSpan="8">Không tìm thấy đại lý</td></tr>
				}				
			</tbody>
		}

		return <div className="mioto-layout page-wrapper"	>
					<Header />
					<SideBar />
					<div className="content-wrapper">
						<div className="page-content fade-in-up">
							<div className="row">
								<div className="col-12">
									<div className="ibox">
										<div className="ibox-head">
											<div className="ibox-title w-100">
												<div className="d-flex justify-content-between align-items-center">
													<h5>Tracking Report</h5>
													<ul className="nav nav-pills">
														<li className="nav-item"><a className={`nav-link ${time === timeFilterModes.DAY ? 'active' : ''} `} onClick={() => this.setTimeMode(timeFilterModes.DAY)} data-toggle="tab">Ngày</a></li>
														<li className="nav-item"><a className={`nav-link ${time === timeFilterModes.WEEK ? 'active' : ''}`} onClick={() => this.setTimeMode(timeFilterModes.WEEK)} data-toggle="tab">Tuần</a></li>
														<li className="nav-item"><a className={`nav-link ${time === timeFilterModes.MONTH ? 'active' : ''}`} onClick={() => this.setTimeMode(timeFilterModes.MONTH )} data-toggle="tab">Tháng</a></li>
													</ul>
												</div>
											</div>
										</div>
									<div className="ibox-body">
										<div className="d-flex justify-content-between align-items-center mb-4">
										<SearchBar search={f2Name} name="f2Name" onHandleSearchEvents={this.onHandleSearchEvents} /> 
												<div className="datepicker flexbox">
													<div className="input-group-icon input-group-icon-left mr-3">
														<span className="input-icon input-icon-right font-16"><i className="ti-calendar"> </i></span>
												<DatePicker
														selected={timeInSeconds}
														onChange={(date) => this.onHandleDateChange(date)}
														className="form-control form-control-rounded form-control-solid"
														timeFormat="HH:mm"
														dateFormat="DD/MM/YYYY"
															/>
													</div>
												</div>
										</div>
									
											<div class="table-responsive">
												<table className="table">
													<thead className="thead-default">
														<tr>
															<th>#</th>
															<th>Tên đại lý</th>
															<th>Yêu cầu đặt xe</th>
															<th>Đã đặt cọc</th>
															<th>Chuyến hoàn thành</th>
															<th>Giá trị chuyến hoàn thành sau KM</th>
															<th>Chuyến sắp tới</th>
															<th>Giá trị chuyến sắp tới sau KM</th>
														</tr>
													</thead>
														{tableContent}
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<Footer />
					</div>
			</div>
	}
}

function mapState(state) {
	return {
		listF2: state.listF2
	}
}

TrackingReport = connect(mapState)(TrackingReport)

export default TrackingReport


// WEBPACK FOOTER //
// ./src/components/dashboard/trackingreport.js